import { createFlagsmithInstance } from 'flagsmith';

const CUSTOMER_FLAGSMITH_ENV_KEY = process.env.VUE_APP_CUSTOMER_FLAGSMITH_ENV_KEY;

export function hasCustomerFeature(identity, flag) {
    if (!identity || !CUSTOMER_FLAGSMITH_ENV_KEY) {
        return Promise.resolve(false);
    }

    const instance = createFlagsmithInstance();

    return instance
        .init({ environmentID: CUSTOMER_FLAGSMITH_ENV_KEY, identity })
        .then(() => instance.hasFeature(flag) === true)
        .catch(() => false);
}

export default { hasCustomerFeature };
